import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../../components/typography';
import { PotentialOffer } from '../../../types';
import { Box, Grid } from '@mui/material';
import { InfoItem } from '../../../components/misc/InfoItem';
import { LoadingPlaceTypes } from '../../../models/booking';

interface OfferDetailsProps {
  offer?: PotentialOffer;
}

const OfferDetails = ({
  offer
}: OfferDetailsProps) => {

  const { t } = useTranslation();

  return (
    <Box sx={{ height: '100%', overflow: 'auto', p: 2}}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('Contact Person:')}</H3>
          <InfoItem title={t('Name')} value={offer?.contactPerson?.firstName || ''} />
          <InfoItem title={t('Last Name')} value={offer?.contactPerson?.lastName || ''} />
          <InfoItem title={t('Email')} value={offer?.contactPerson?.email || ''} />
          <InfoItem title={t('Mobile Phone')} value={offer?.contactPerson?.mobilePhone || ''} />
          <InfoItem title={t('Business Phone')} value={offer?.contactPerson?.businessPhone || ''} />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('Loading Places')}</H3>
          {offer?.loadingPlaces
            .filter(place => place.loadingType === LoadingPlaceTypes.LOADING)
            .map(({address}, index) => (
              <H4 key={index}>{index + 1} - {address.country} , {address.city}, {address.postalCode}</H4>
            ))}
          <Box sx={{ mt: 2 }} />
          <H3>{t('Unloading Places')}</H3>
          {offer?.loadingPlaces
            .filter(place => place.loadingType === LoadingPlaceTypes.UNLOADING)
            .map(({address}, index) => (
              <H4 key={index}>{index + 1} - {address.country} , {address.city}, {address.postalCode}</H4>
            ))}
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('Truck')}</H3>
          <InfoItem title={t('Type')} value={offer?.vehicleProperties?.type?.join(', ') || 'N/A'} />
          <InfoItem title={t('Body')} value={offer?.vehicleProperties.body?.join(', ') || 'N/A'} />
          <InfoItem title={t('Body Property')} value={offer?.vehicleProperties.bodyProperty?.join(', ') || 'N/A'} />
          <InfoItem title={t('Equipments')} value={offer?.vehicleProperties.equipment?.join(', ') || 'N/A'} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ borderTop: '1px solid #e0e0e0', paddingTop: '16px', marginTop: '16px' }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('W/L')}</H3>
          <InfoItem title={t('Weight')} value={offer?.weightT || 'N/A'} />
          <InfoItem title={t('Length')} value={offer?.lengthM || 'N/A'} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('Payment')}</H3>
          <InfoItem title={t('Payment Due Within Days')} value={offer?.paymentDueWithinDays || 'N/A'} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <H3>{t('Additional Information')}</H3>
          <InfoItem title={t('Additional Information')} value={offer?.additionalInformation?.join(', ') || 'N/A'} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OfferDetails;
